import { connect } from 'react-redux';
import { viewRadioPlayerStart } from 'store/playerRadio/playerRadio.actions';
import {
  radioStationHeartStart,
  deleteHeartRadioStationStart,
} from 'store/userhistoryRadio/userhistoryRadio.actions';
import { showSnackbarNotification } from 'store/notification/notification.actions';

const mapStateToProps = (state) => ({
  radioState: state.radio,
  userHistoryRadioState: state.userhistoryRadio,
});

const mapDispatchToProps = (dispatch) => ({
  onViewRadioPlayerStart: (id) => dispatch(viewRadioPlayerStart(id)),
  onFavouriteRadioStation: (value) =>
    dispatch(radioStationHeartStart(value)),
  onDeleteFavoriteRadioStation: (value) =>
    dispatch(deleteHeartRadioStationStart(value)),
  onShowSnackbarNotification: (message) =>
    dispatch(showSnackbarNotification(message)),
});

const container = connect(mapStateToProps, mapDispatchToProps);

export default container;
